import { render } from "./DateDiffChip.vue?vue&type=template&id=016ebfd6"
import script from "./DateDiffChip.vue?vue&type=script&lang=js"
export * from "./DateDiffChip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__